import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 998;

  @media screen and ${breakpoints.tablet.max.sm} {
    position: sticky;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: ${({ theme }) =>
      theme.colorTokens.component.betslip.background};
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.space["space-5"]} 0;

  @media screen and ${breakpoints.desktop.min.md} {
    padding: ${({ theme }) => theme.space["space-5"]};
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;
